import type { Config } from '@brighterion/types/config';
import config from './config.dev.json';

export async function getConfig(): Promise<Config> {
    if (process.env.NODE_ENV === 'development') return config as Config;

    // expect config.prod.json to be at the root of the s3 bucket
    const response = await fetch('/config.prod.json');
    const data: Config = await response.json();
    return data;
}
